import { FloatFooter } from "../navigation/FloatFooter";
import { NavbarLogin } from "../navigation/NavbarLogin";

export const LoginPrev = (props) => {
  return (
    <>
      <NavbarLogin />

      <div className="min-h-full lg:flex">
        <div className="block lg:hidden">
          <div>
            <div>
              <img
                className=""
                src="/jpeg/nino_mirando_galilea.jpeg"
                alt="Galilea-ship"
              />
            </div>
          </div>
        </div>

        <div className="w-full pt-12 px-8 mb-10">
          <div className="max-w-md mx-auto">
            <div className="lg:pt-20">
              <h2
                className="lg:mt-6 text-4xl md:text-5xl font-bold text-center"
                autoFocus
              >
                <div className={props.classVeri}>{props.title}</div>
              </h2>
              <p className="mt-4 text-lg leading-6 text-gray-500">
                {props.description}
              </p>
            </div>
            <div className="mt-8">
              <div className="mt-6">{props.form}</div>
            </div>
            <FloatFooter />
          </div>
        </div>

        <div className="hidden lg:block lg:w-5/6 relative">
          <div>
            <div className="fixed">
              <img
                className=" h-screen"
                src="/jpeg/nino_mirando_galilea.jpeg"
                alt="Galilea-ship"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
